import { endpointsList } from '@/helpers';
import axios from 'axios';

export class RedirectionService {
  public static async getProjectRoomUrl(projectTitle: string): Promise<string> {
    const response = await axios.get(
      endpointsList.redirections.getDaisyProjectRoomUrl(projectTitle),
    );
    return response.data;
  }
}
